
export const MIN_STRING_LENGTH = 1

export const MIN_VALUE = 0

export const MIN_VALUE_REPETITION = 1



